<template>
  <div id="footer" >
    <div class="footer">
          <div class="footer-con">

            <img class="action-bg" src="@/assets/img/join/images/img_24.png" />
            <div class="footer-item">
              <div class="footer-nav"><a :href="'/' + currentLang + '/home'" @click.prevent="goRouter('/home','0')"><span class="heng"></span>{{ $t(`header.home`) }}</a></div>
              <div class="footer-nav"><a :href="'/' + currentLang + '/AboutKangLin'" @click.prevent="goRouter('/AboutKangLin','1')"><span class="heng"></span>{{ $t(`header.aboutkl`) }}</a></div>

              <div class="footer-nav"><a :href="'/' + currentLang + '/Production'" @click.prevent="goRouter('/Production','2')"><span class="heng"></span>{{ $t(`header.product`) }}</a>
              </div>
              <div class="footer-nav">
                <a :href="'/' + currentLang + '/prefecture'" @click.prevent="goRouter('/prefecture','3')"><span class="heng"></span>{{ $t(`header.patientZone`) }}</a>
              </div>



            </div>


            <div class="footer-item">
              <div class="footer-nav">
                <a :href="'/' + currentLang + '/news'" @click.prevent="goRouter('/news','4')"><span class="heng"></span>{{ $t(`header.news`) }}</a>
              </div>
              <div class="footer-nav">
                <a :href="'/' + currentLang + '/Enterprise'" @click.prevent="goRouter('/Enterprise','5')"><span class="heng"></span>{{ $t(`header.enterprise`) }}</a>
              </div>

              <div class="footer-nav">
                <a :href="'/' + currentLang + '/teamwork'" @click.prevent="goRouter('/teamwork','6')"><span class="heng"></span>{{ $t(`header.expansion`) }}</a>
              </div>
            </div>




            <div class="footer-item footer-item-last">
                <div class="organization-wrap">
                  <div class="organization"><span class="">0571-86870039</span> <img class="icon" src="@/assets/img/phone1.svg" /></div>
                  <div class="organization"><span>zhoujiahui@kanglinbio.com</span><img class="icon" src="@/assets/img/phone2.svg" /> </div>

                  <div class="organization"><span class="long-text">{{ $t('gsxg.dizhi') }}</span> <img class="icon" src="@/assets/img/phone.svg" /></div>
              </div>
            </div>

            <div class="back-top" @click="GoTop">
              <img class="media-2" src="@/assets/img/top.png" />
            </div>

          </div>
      <div class="desc-wrapper">
          <span class="desc-4" @click="openaddress">Copyright © 2021-2022 康霖生物科技（杭州）有限公司
            浙ICP备2022003670号-1</span>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  computed: {
    currentLang() {
      return (localStorage.getItem('lang') || 'EN').toLowerCase()
    }
  },
  methods: {
    GoTop() {
      (function smoothscroll() {
        var currentScroll =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          window.requestAnimationFrame(smoothscroll);
          window.scrollTo(0, currentScroll - currentScroll / 10);
        }
      })();
    },
    goRouter(path, index){
      window.scrollTo(0, 0)
      sessionStorage.setItem('navIndex', index)
      const lang = (localStorage.getItem('lang') || 'EN').toLowerCase()
      this.$router.push('/' + lang + path)
    },
    openaddress(){
      window.open('https://beian.miit.gov.cn/#/Integrated/recordQuery')
    }
  }
};
</script>
<style lang="less" scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #06488D;
  overflow: hidden;
  padding-top: 100px;
}
.heng{
  display: inline-block;
    width: 20px;
    height: 2px;
    opacity: 0.5;
    border-bottom: 1px solid #FFFFFF;
    position: relative;
    top: -8px;
    margin-right:16px;
}
.footer .group-17 {
  background-color: #06488D;
  background-repeat: no-repeat, no-repeat;
  background-position: 1335px 300px, 1347px 207px;
  background-size: 22px 7px, 9px 9px;
  padding-top: 100px;
  width: 1440px;
  margin: 0 auto;
}
.footer .group-18 {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-self: center;
  width: 1440px;
}
.footer .group-18 .cursorpointer:hover,.footer .group-18 .cursorpointer span:hover{
  color:hsla(0,0%,100%,1)
}
.footer .block-6 {
  display: flex;
  justify-content: flex-start;
  align-self: center;
  width: 1276px;
}
.footer .action-bg {
  width: 162px;
  height: 72px;
}
.footer .container-6 {
  display: flex;
  flex-direction: column;
  margin-left: 202px;
  justify-content: flex-start;
  align-self: flex-end;
  height: 88px;
}
.footer .label-6 {
  color: rgba(255, 255, 255, 0.5);
  font-size: 20px;
  
  line-height: 28px;
  align-self: flex-start;
  max-width: 120px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.footer .tag-wrapper {
  display: flex;
  margin-top: 32px;
  justify-content: flex-start;
  align-self: center;
  width: 80px;
}
.footer .tag-5 {
  color: rgba(255, 255, 255, 0.5);
  font-size: 20px;
  
  line-height: 28px;
  align-self: flex-start;
  white-space: nowrap;
}
.footer .container-7 {
  display: flex;
  flex-direction: column;
  margin-left: 243px;
  justify-content: flex-start;
  align-self: flex-end;
  height: 88px;
}
.footer .tag-wrapper-1 {
  display: flex;
  justify-content: flex-start;
  align-self: center;
  width: 120px;
}
.footer .tag-6 {
  color: rgba(255, 255, 255, 0.5);
  font-size: 20px;
  
  line-height: 28px;
  align-self: flex-start;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.footer .word-wrapper {
  display: flex;
  margin-top: 32px;
  justify-content: flex-start;
  align-self: center;
  width: 120px;
}
.footer .word-4 {
  color: rgba(255, 255, 255, 0.5);
  font-size: 20px;
  
  line-height: 28px;
  align-self: flex-start;
  white-space: nowrap;
}
.footer .container-8 {
  display: flex;
  justify-content: flex-start;
  align-self: flex-end;
  position: relative;
  margin: 0 0 48px 454px;
}
.footer .thumbnail-5 {
  width: 40px;
  height: 40px;
  align-self: flex-start;
}
.footer .media-2 {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: -16px;
  transform: translateX(-50%);
}
.footer .block-7 {
  display: flex;
  margin-top: 18px;
  justify-content: flex-start;
  align-self: center;
  width: 1276px;
}
.footer .container-9 {
  padding-top: 14px;
  display: flex;
  flex-direction: column;
  margin-left: 364px;
  justify-content: flex-start;
  align-self: flex-start;
  height: 102px;
}
.footer .word-wrapper-1 {
  display: flex;
  justify-content: flex-start;
  align-self: center;
  width: 120px;
}
.footer .word-5 {
  color: rgba(255, 255, 255, 0.5);
  font-size: 20px;
  
  line-height: 28px;
  align-self: flex-start;
  white-space: nowrap;
}
.footer .word-wrapper-2 {
  display: flex;
  margin-top: 32px;
  justify-content: flex-start;
  align-self: center;
  width: 120px;
}
.footer .word-6 {
  color: rgba(255, 255, 255, 0.5);
  font-size: 20px;
  
  line-height: 28px;
  align-self: flex-start;
  max-width: 120px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.footer .location-wrapper {
  display: flex;
  justify-content: flex-start;
  align-self: flex-start;
  margin: 14px 0 0 206px;
}
.footer .location {
  color: rgba(255, 255, 255, 0.5);
  font-size: 20px;
  
  line-height: 28px;
  align-self: flex-start;
  white-space: nowrap;
}
.footer .container-10 {
  padding-bottom: 2px;
  display: flex;
  margin-left: 50px;
  justify-content: space-between;
  align-self: flex-start;
  height: 102px;
  width: 304px;
}
.footer .wrapper-5 {
  height: 100px;
}
.footer .wrapper-5 span{
  line-height:24px;
}
.footer .telephone {
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
  margin-right:28px;
  line-height: 20px;
  align-self: flex-end;
  max-width: 258px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.footer .organization {
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
  text-align:right;
  line-height: 24px;
  margin-top: 16px;
  width: 370px;
  height: 24px;
  position: relative;

  span{
    vertical-align: middle;
  }
  .long-text{
    position: absolute;
    right: 33px;
    top: 0;
    width: 330px;
  }
}
.footer .wrapper-6 {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-self: center;
  position: relative;
  height: 100px;
  padding: 2px 0 10px;
}

.wrapper-6 img{
  opacity: 0.5;
}
.footer .icon {
  width: 24px;
height: 24px;
  align-self: center;
  margin-left: 12px;
  display: inline-block;
  opacity: 0.6;
}
.footer .icon-1 {
  width: 24px;
height: 24px;
  margin-top: 13px;
  align-self: center;
}
.footer .icon-2 {
  width: 24px;
height: 24px;
  position: absolute;
  left: 50%;
  bottom: -3px;
  z-index: 1;
  transform: translateX(-50%);
}
.footer .dot-2 {
  width: 6px;
  height: 7px;
  align-self: center;
  z-index: 2;
  margin: 25px 1px 0 0;
}
.footer .desc-wrapper {
  background-color: #222D44;
  display: flex;
  margin-top: 100px;
  justify-content: center;
  align-self: center;
  width: 100%;
  padding: 20px 12px;
}
.footer .desc-4 {
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
  cursor: pointer;
  line-height: 20px;
  margin-right: 2px;
  align-self: flex-start;
  max-width: 1412px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}



.footer-con{
  display: flex;
  width: 1280px;
  margin: 0 auto;
  position: relative;

justify-content: space-between; 
.footer-nav{
  font-size: 20px;
  text-align: left;
  height: 20px;
  line-height: 20px;
  margin-bottom: 33px;
  color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  &:last-child{
    margin-bottom: 0px;
  }
  a {
    color: inherit;
    text-decoration: none;
    &:hover {
      color: rgba(255, 255, 255, 1);
    }
  }
}
 .back-top{
    position: absolute;
    top: 0;
    right: 0;cursor: pointer;
  }
}


.footer-item-last{
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  right: -20px;
  position: relative;
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue